// Componenti di base dell'interfaccia (bottoni, pannelli, campi), sul modello
// del design system SURVMAPS di OmniSurv. Lo stile è in theme/survmaps.css.

import React from "react";
import Icon from "./Icon";

export function Button({ variant = "primary", size, block, icon, busy, disabled, children, className = "", ...rest }) {
  const cls = [
    "sm-btn",
    `sm-btn--${variant}`,
    size === "sm" && "sm-btn--sm",
    block && "sm-btn--block",
    className,
  ].filter(Boolean).join(" ");
  return (
    <button type="button" className={cls} disabled={busy || disabled} {...rest}>
      {busy ? <span className="sm-spinner" /> : icon && <Icon name={icon} size={size === "sm" ? 14 : 16} />}
      {children}
    </button>
  );
}

export function IconButton({ icon, label, active, className = "", ...rest }) {
  return (
    <button
      type="button"
      className={`sm-icon-btn${active ? " is-active" : ""} ${className}`}
      aria-label={label}
      title={label}
      aria-pressed={active === undefined ? undefined : !!active}
      {...rest}
    >
      <Icon name={icon} />
    </button>
  );
}

export function Panel({ title, onClose, side = "left", wide, footer, children, className = "" }) {
  return (
    <section
      className={`sm-panel${side === "right" ? " sm-panel--right" : ""}${wide ? " sm-panel--wide" : ""} ${className}`}
      aria-label={title}
    >
      <header className="sm-panel-head">
        <h2 className="sm-panel-title" style={{ margin: 0 }}>{title}</h2>
        {onClose && <IconButton icon="x" label="Chiudi" onClick={onClose} />}
      </header>
      <div className="sm-panel-body">{children}</div>
      {footer && <footer className="sm-panel-foot">{footer}</footer>}
    </section>
  );
}

export function Field({ label, htmlFor, children }) {
  return (
    <div className="sm-field">
      <label className="sm-label" htmlFor={htmlFor}>{label}</label>
      {children}
    </div>
  );
}

export function Check({ checked, onChange, children, disabled }) {
  return (
    <label className="sm-check" style={disabled ? { opacity: 0.45, cursor: "not-allowed" } : undefined}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
      {children}
    </label>
  );
}

export function Tabs({ value, onChange, options }) {
  return (
    <div className="sm-tabs" role="tablist">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={value === o.value}
          className={`sm-tab${value === o.value ? " is-active" : ""}`}
          disabled={o.disabled}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export function Dock({ children }) {
  return <nav className="sm-dock" aria-label="Strumenti">{children}</nav>;
}

export function DockSep() {
  return <div className="sm-dock-sep" />;
}

export function Dialog({ title, onClose, footer, children }) {
  return (
    <div className="sm-scrim" onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="sm-dialog" role="dialog" aria-modal="true" aria-label={title}>
        <header className="sm-panel-head">
          <h2 className="sm-panel-title" style={{ margin: 0 }}>{title}</h2>
          {onClose && <IconButton icon="x" label="Chiudi" onClick={onClose} />}
        </header>
        <div className="sm-panel-body">{children}</div>
        {footer && <footer className="sm-panel-foot">{footer}</footer>}
      </div>
    </div>
  );
}

export function LoadingOverlay({ label, progress }) {
  return (
    <div className="sm-loading">
      <div className="sm-loading-box">
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span className="sm-spinner" />
          {label}
        </div>
        {progress != null && (
          <div className="sm-progress"><div style={{ width: `${Math.round(progress * 100)}%` }} /></div>
        )}
      </div>
    </div>
  );
}

export function Swatch({ swatch }) {
  return <span className="sm-swatch" style={swatch} />;
}

// Coordinate "lat, lng" in formato leggibile.
export function formatLatLng(latlng) {
  return `${latlng.lat.toFixed(6)}, ${latlng.lng.toFixed(6)}`;
}
